<div class="d-flex gx-2 mt-2">
    @switch (itemType){
        @case ('kudosItem'){
            <div class="text-secondary preview-icon pe-1">
                <i class="fa-solid fa-bell"></i>
            </div>
            <div class="">
                <div class="px-3">
                    {{'kudos-creation-dialog.notification-preview' | translate}}
                </div>
            </div>
        }
        @default{
            @if(notify){
                <div class="text-secondary preview-icon pe-1">
                    <i class="fa-solid fa-bell"></i>
                </div>
                <div class="">
                    <div class="px-3">
                        {{'timeline-item-creation-dialog.notification-preview' | translate}}
                    </div>
                </div>
            }@else{
                <div class="text-secondary preview-icon pe-1">
                    <i class="fa-solid fa-bell-slash"></i>
                </div>
                <div class="">
                    <div class="px-3">
                        {{ 'timeline-item-creation-dialog.notification-preview.no' | translate }}
                    </div>
                </div>
            }
        }
    }
</div>
      